import styled from '@emotion/styled'
import { Header, Paragraph } from 'components/patterns'
import { themeColor } from 'utils/styles'

export const SourceFeaturesTitle = styled.h4`
  font-size: 16px;
  color: ${themeColor('blackSecondary')};
  line-height: 1.38;
  font-weight: bold;
  margin: 0;
`

export const OutputNameText = styled(Paragraph)`
  color: ${themeColor('blackSecondary')};
`
export const CountText = styled.span`
  font-weight: bold;
`
export const StyledHeader = styled(Header)`
  display: flex;
  gap: 16px;
`
